import { comments } from "@/mocks/home";

export default function SectionComments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">观众热评</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">百万用户的真实观影体验</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                &ldquo;{item.content}&rdquo;
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  {item.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}